import { useInView } from './hooks';
import './ContextChips.css';

export const CONTEXT_LINE =
  'Form alone doesn\u2019t find winners. HorseStat shows how form, stats and conditions fit together, so you spot the value others miss.';

const CHIPS = [
  {
    id: 'races',
    label: 'Every UK & Irish race',
    icon: (
      <>
        <path d="M5 21V4" />
        <path d="M5 4h12l-2.5 4L17 12H5" />
      </>
    ),
  },
  {
    id: 'tables',
    label: '22 analysis tables',
    icon: (
      <>
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 10h18M9 10v10" />
      </>
    ),
  },
  {
    id: 'sims',
    label: '10,000 simulations per race',
    icon: <path d="M3 12h4l3-8 4 16 3-8h4" />,
  },
];

function ContextChips({ className }) {
  const [ref, inView] = useInView({ threshold: 0.5 });

  return (
    <ul ref={ref} className={`context-chips${inView ? ' is-in-view' : ''}${className ? ` ${className}` : ''}`}>
      {CHIPS.map((chip, index) => (
        <li key={chip.id} className="context-chip" style={{ '--chip-index': index }}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            {chip.icon}
          </svg>
          <span>{chip.label}</span>
        </li>
      ))}
    </ul>
  );
}

export default ContextChips;
